<template>
  <div class='cirFanConfig'>
    <div class='wrapHeader'>
      <el-form :inline="true" class="demo-form-inline" :model="fanWareModel">
        <el-form-item label="仓房选择">
          <el-select v-model="fanWareModel.wareId" @change='wareChange' placeholder="仓房选择">
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='wareModel' :style="`height:${height}px`">
        <img :src='wareModel'>
        <el-button type="primary" class='commonBtn addFan' @click='addFan'>添加风机</el-button>
        <el-button type="primary" class='commonBtn saveFanModel' @click='saveFanModel'>保存配置</el-button>
        <el-button :type="btnType" class='commonBtn switchModel' @click='switchModel'>{{orientation}}</el-button>
        <div class='fanList' v-if='fanWareModel.fanList.length>0&&orientation=="正面"'>
          <div 
            :class='["fanItem",fanStyle]' 
            :style="`top:${item.fanY}px;left:${item.fanX}px`" 
            @mousedown="startDrag($event,index)" 
            v-for="(item,index) in fanWareModel.fanList" :key='index'>
            <div>
              <span class="fanName">{{item.fanName}}</span>
            </div>
          </div>
        </div>
        <div class="fanList" v-else>
          <div 
            :class='["fanItem",fanStyle]' 
            :style="`top:${item.fanY}px;left:${item.fanX}px`" 
            @mousedown="startDrag($event,index)" 
            v-for="(item,index) in fanWareModel.fanAfterList" :key='index'>
            <div><span class="fanName">{{item.fanName}}</span></div>
          </div>
        </div>
        <div class='modelConfigWrap'>
          <div class='addModelWrap'>
            <div class='modelWrap' @click='changeWareModel(1)'>
              <div class='model model1'></div>
            </div>
            <div>仓房模型1</div>
          </div>
          <div class='addModelWrap'>
            <div class='modelWrap' @click='changeWareModel(2)'>
              <div class='model model2'></div>
            </div>
            <div>仓房模型2</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="`${wareName}配置信息`" :visible.sync="configView"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg configInfoWrap"'>
      <div class='formWrap'>
        <el-form label-width="115px" :model="fanWareModel" ref='fanWareModel' :rules='FanInfoRules'>
          <div class='baseInfoTitle' style="padding-top:10px"><span></span>基本信息</div>
          <div class='dialog-setWrap'>
            <el-form-item label="关联控制器" prop='serId'>
              <el-select v-model="fanWareModel.serId" placeholder="关联控制器">
                <el-option :label="ser.serName" :value="ser.serId" v-for='ser in serList' :key='ser.serList'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="正面环流机" prop='FZfanNum'>
              <el-select v-model="fanWareModel.FZfanNum" placeholder="正面环流机数量" @change="setFZfanNum">
                <el-option :label="num" :value="num" v-for='num in 10-fanWareModel.BZfanNum' :key='num'></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="反面环流机" prop='BZfanNum'>
              <el-select v-model="fanWareModel.BZfanNum" placeholder="反面环流机数量" @change="setBZfanNum">
                <el-option :label="num" :value="num" v-for='num in 10-fanWareModel.FZfanNum' :key='num'></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if='fanWareModel.FZfanNum>0'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>正面环流风机信息</div>
            <div class='dialog-setWrap'>
              <el-form-item 
                :label="`${index+1}号风机编号`" 
                :prop='"fanList."+index+".fanNo"' 
                v-for='(item,index) in fanWareModel.fanList' 
                :key="index"
                :rules="[{
                  required: true, message: '风机编号不能为空', trigger: 'blur',
                },{
                  trigger:'blur',validator:ruleNo
                }]">
                <el-input v-model="item.fanNo" ></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if='fanWareModel.BZfanNum>0'>
            <div class='baseInfoTitle' style="padding-top:10px"><span></span>反面环流风机信息</div>
            <div class='dialog-setWrap'>
              <el-form-item 
                :label="`${Number(fanWareModel.FZfanNum)+index+1}号风机编号`" 
                :prop='"fanAfterList."+index+".fanNo"' 
                v-for='(item,index) in fanWareModel.fanAfterList' 
                :key="index"
                :rules="[{
                  required: true, message: '风机编号不能为空', trigger: 'blur',
                },{
                  trigger:'blur',validator:ruleNo
                }]">
                <el-input v-model="item.fanNo" ></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="setFanNum('fanWareModel')">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
import wareModel1 from '../../assets/cir/wareModel1.jpg'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      wareName:'',
      wareList:[],
      btnType:'primary',
      orientation:'正面',
      wareModel:wareModel1,
      configView:false,
      serList:[],
      fanWareModel:{
        wareId:'',
        picNo:'1',
        serId:'',
        FZfanNum:0,
        BZfanNum:0,
        fanList:[],
        fanAfterList:[],
      },
      FanInfoRules:{
        serId:[{trigger:'blur',message:'关联控制器不能为空',required:true}]
      },
      fanStyle:'fanItem1'
    }
  },
  created(){
    this.getWareList();
    this.setScale()
  },
  methods:{
    ruleNo(rule,val,callback){
      if(val<1||val>10){
        callback(new Error('请输入大于1-10的数字'))
      }else{
        callback()
      }
    },
    setScale(){
      if(this.width>1680){
        this.scale=1
      }else if(this.width>1600&&this.width<=1680){
        this.scale=1450/1690
      }else if(this.width>1440&&this.width<=1600){
        this.scale=1370/1690
      }else if(this.width>1024&&this.width<=1440){
        this.scale=1210/1690
      }else{
        this.scale=794/1690
      }
    },
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res){
          this.wareList=res.data;
          this.fanWareModel.wareId=res.data[0].wareId;
          this.wareName=res.data[0].wareName;
          this.getFanList();
          this.getserList()
        }
      })
    },
    wareChange(){
      this.getFanList()
    },
    getFanList(){
      axios.get(`/system/fan/selectNhlFanByWareId/${this.fanWareModel.wareId}`).then(res=>{
        if(res){
          this.fanWareModel.serId=res.data.serId;
          this.fanWareModel.picNo=res.data.picNo?res.data.picNo:'1';
          this.fanStyle=res.data.picNo?'fanItem'+res.data.picNo:'fanItem1'
          this.fanWareModel.FZfanNum=res.data.fanList.length?res.data.fanList.length:'';
          this.fanWareModel.BZfanNum=res.data.fanAfterList.length?res.data.fanAfterList.length:'';
          this.fanWareModel.fanList=res.data.fanList;
          this.fanWareModel.fanAfterList=res.data.fanAfterList;
          this.wareModel=res.data.picNo?require('../../assets/cir/wareModel'+res.data.picNo+'.jpg'):wareModel1;
        }
      })
    },
    setBZfanNum(){
      if(this.fanWareModel.BZfanNum<this.fanWareModel.fanAfterList.length){
        this.fanWareModel.fanAfterList.length=this.fanWareModel.BZfanNum
      }else{
        let arr=[];
        for(let i=0;i<this.fanWareModel.BZfanNum-this.fanWareModel.fanAfterList.length;i++){
          arr.push({
            fanX:i*79.92,
            fanY:0,
            fanDirection:1,
            fanNo:''
          })
        }
        this.fanWareModel.fanAfterList=[...this.fanWareModel.fanAfterList,...arr];
      }
    },
    getserList(){
      axios.get('/system/ser/getSerSelect',{params:{serType:'DEVNHLSYS'}}).then(res=>{
        if(res){
          this.serList=res.data;
        }
      })
    },
    addFan(){
      this.configView=true;
    },
    setFZfanNum(){
      if(this.fanWareModel.FZfanNum<this.fanWareModel.fanList.length){
        this.fanWareModel.fanList.length=this.fanWareModel.FZfanNum;
      }else{
        let arr=[];
        for(let i=0;i<this.fanWareModel.FZfanNum-this.fanWareModel.fanList.length;i++){
          arr.push({
            fanX:i*79.92,
            fanY:0,
            fanDirection:0,
            fanNo:''
          })
        }
        this.fanWareModel.fanList=[...this.fanWareModel.fanList,...arr];
      }
    },
    setFanNum(obj){
      this.$refs[obj].validate(valid=>{
        if(valid){
          this.fanWareModel.fanList.forEach((item,index)=> {
            item.fanName=(index+1)+'号风机'
          });
          this.fanWareModel.fanAfterList.forEach((item,index)=>{
            item.fanName=(index+1+this.fanWareModel.FZfanNum)+'号风机'
          })
          this.configView=false
        }else{
          return false
        }
      })
    },
    switchModel(){
      if(this.btnType=='primary'){
        this.btnType='info'
        this.orientation='反面'
      }else{
        this.btnType='primary'
        this.orientation='正面'
      }
    },
    saveFanModel(){
      axios.post('/system/fan/save',this.fanWareModel).then(res=>{
        if(res){
          this.$message({
            type: 'success',
            message: '保存成功!',
            duration:1000
          });
          this.getFanList()
        }
      })
    },
    changeWareModel(num){
      this.wareModel=require('../../assets/cir/wareModel'+num+'.jpg');
      this.fanWareModel.picNo=num;
      this.fanStyle='fanItem'+num

    },
    startDrag($event,num){
      let that=this;
      // 开始
      let dom=document.querySelector('.fanItem');
      dom.style.cursor='move'
      window.onmousemove=function(event){
        if(that.orientation=='正面'){
          that.fanWareModel.fanList[num].fanX=event.movementX+Number(that.fanWareModel.fanList[num].fanX)
          that.fanWareModel.fanList[num].fanY=event.movementY+Number(that.fanWareModel.fanList[num].fanY)
        }else{
          that.fanWareModel.fanAfterList[num].fanX=event.movementX+Number(that.fanWareModel.fanAfterList[num].fanX)
          that.fanWareModel.fanAfterList[num].fanY=event.movementY+Number(that.fanWareModel.fanAfterList[num].fanY)
        } 
      }
      // 停止
      window.onmouseup = function () {
        window.onmousemove = null;
        dom.style.cursor='default'
        return
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .cirFanConfig{
    .wareModel{
      overflow: hidden;
      position: relative;
      width: 1690px;
      min-height:887px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      user-select: none;
      img{
        width: 1690px;
        height: auto;
      }
      .saveFanModel{
        right: 150px;
      }
      .addFan{
        right:285px;
      }
      .switchModel{
        right: 15px;
      }
      .fanList{
        position: absolute;
        z-index: 100;
        top:0px;
        left:0px;
        height:887px;
        width: 1690px;
        .fanItem{
          background-image: url('../../assets/cir/fan.png');
          background-size: cover;
          position: absolute;
          .fanName{
            position: absolute;
            left: 20px;
            font-size: 12px;
            padding: 5px;
            background: white;
            white-space: nowrap
          }
        }
        .fanItem1{
          height: 250px;
          width:80.43px;
          .fanName{
            top: 75px;
          }
        }
        .fanItem2{
          height: 207px;
          width: 66px;
          .fanName{
            top: 60px;
          }
        }
        .fanItem>div{
          height: 100%;
          width: 100%;
          position: relative;
        }
      }
      .modelConfigWrap{
        position: absolute;
        bottom: 0;
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        height: 150px;
        width: 1690px;
        .addModelWrap{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .modelWrap{
            border: 1px solid rgba(0,0,0,0.3);
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            z-index: 102;
            height: 110px;
            width: 150px;
            margin:0 10px;
            .model{
              background-size: cover;
              width: 150px;
              height: 84.375px;
            }
            .model1{
              background-image: url('../../assets/cir/wareModel1.jpg');
            }
            .model2{
              background-image: url('../../assets/cir/wareModel2.jpg');
            }
          }
        }
      }
    }
  }
</style>
